<section>
    <div class="header">
        <h2>{{ pageData.header }}</h2>
        <p class="header-text">{{ pageData.paragraph }}</p>
    </div>
    <div class="search-country">
        <label for="search country">{{ pageData.searchLabel }}</label>
        <xm-search class="search" [textBoxPlaceHolder]="pageData.searchPlaceholder"
            (countryDetails)="setSelectedCountry($event)"></xm-search>
    </div>
    <div *ngIf="hasSelectedCountry">
        <div class="not-found" *ngIf="!countryFound">
            <xm-media-image class="not-found-icon" [imageOptions]="notFoundIcon" size="width"></xm-media-image>
            <p class="not-found-disclaimer" *ngIf="!countryFound">{{ pageData.notFoundDisclaimer }}</p>
        </div>
    </div>
    <div *ngIf="!hasSelectedCountry || (hasSelectedCountry && countryFound)">
        <xm-travel-rate-details [rateDetails]="rateDetails" [pageData]="pageData" [showGtpLink]="showGtpLink"
            (gtpLauncher)="launchGtpFlow()"></xm-travel-rate-details>
    </div>
    <button class="xm-btn-primary-light primary-btn" (click)="navigateBack()">{{ pageData.primaryBtn }}</button>
</section>
